/**
 * De dónde se baja react_config.json.
 *
 * Se resuelve relativo a PUBLIC_URL, que CRA fija en build (sin barra final):
 *   - contenedor (Dockerfile pone PUBLIC_URL=/)        -> /react_config.json
 *   - build para el monolito (.env.production)          -> /ContentS/react/react_config.json
 *   - desarrollo local (PUBLIC_URL vacío)               -> /react_config.json
 *
 * En el contenedor el archivo NO viene del build: lo genera el entrypoint de nginx
 * a partir de las variables de entorno al arrancar (ver docker/10-react-config.sh).
 */
export const getConfigUrl = (): string => {
  const base = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
  return `${base}/react_config.json?v=${Date.now()}`;
};
